import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M25 15v-.26C25 10 20.77 7 16 7s-9 3-9 7.74V15c-1.1 0-2 .9-2 2v1c0 1.1.9 2 2 2h.2c.33 1.3 1.14 2.59 2.8 3.34.85.38 1.94.53 2.96.6.91.06 1.88.06 2.72.06h.64c.84 0 1.83 0 2.78-.06 1.04-.07 2.16-.22 3.02-.6 1.67-.75 2.41-2.06 2.7-3.34H25c1.1 0 2-.9 2-2v-1c0-1.1-.9-2-2-2zm-17-.26C8 10.73 11.58 8 16 8s8 2.73 8 6.74c0 .09 0 .17-.01.26H8.01C8 14.91 8 14.83 8 14.74zm13.71 7.69c-1.28.58-3.58.57-5.38.57h-.66c-1.79 0-3.99.01-5.26-.57-1.21-.55-1.86-1.45-2.17-2.43h15.55c-.27.98-.88 1.88-2.08 2.43zM26 18c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-1c0-.55.45-1 1-1h18c.55 0 1 .45 1 1v1z",
      clipRule: "evenodd",
      fill: "currentColor",
      fillRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      d: "M12 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM16 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM20 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
      fill: "currentColor"
    })]
  }));
};
export default SvgComponent;